module.exports = __webpack_public_path__ + "media/news/leipzig-news-03-7d0032f6.webp";